var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_28625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68669 69.83L0 0.130859L67.9138 0.270923L61.9007 69.83L34.2132 77.8703L5.68669 69.83Z",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2148 71.1377V6.76758L62.1822 6.86095L57.1949 64.4526L34.2148 71.1377Z",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4887 22.85L55.2807 14.3418H12.2578L14.6348 40.4267H44.3268L43.1624 51.5522L33.6534 54.1227L24.0047 51.3182L23.4921 44.6802H14.9612L16.1267 58.2368L33.6528 63.1451L51.3186 58.2368L53.6956 31.7784H22.5128L21.6272 22.85H54.4887Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_28625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.9138,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg12);
export default __webpack_public_path__ + "static/media/img12.37dee0ef6f463c38021cd6e6d2dca8fa.svg";
export { ForwardRef as ReactComponent };